<div class="display-picture">
  <img *ngIf="picture" [src]="picture" [style.height.px]="size" [style.width.px]="size">

  <div *ngIf="!picture" class="default-picture custom-backdrop text-primary-contrast" [style.height.px]="size"
    [style.width.px]="size" [style.line-height.px]="size" [style.font-size.px]="size/2">
    {{full_name.substr(0, 1)}}
  </div>
</div>